import { type Skeleton } from '../../lib/skeleton/core';
import type { MappingResult } from '../../lib/recognize/config';

export function formatAssignmentLabel(value: string): string {
  return value
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Za-z])(\d)/g, '$1 $2')
    .replace(/(\d)([A-Za-z])/g, '$1 $2');
}

export function getBoneDisplayName(
  skeleton: Skeleton | null,
  boneRef: string | null,
): string | null {
  if (!boneRef) return null;
  if (!skeleton) return boneRef;
  const boneIndex = skeleton.resolveBoneRef(boneRef, { namespace: 'internal' });
  if (boneIndex === null) return boneRef;
  return skeleton.bone(boneIndex).name;
}

export function getRoleForBone(
  mapping: MappingResult | null,
  boneRef: string | null,
): string | null {
  if (!mapping || !boneRef) return null;
  for (const [roleName, assignedBoneRef] of Object.entries(mapping.roleToBone)) {
    if (assignedBoneRef === boneRef) return roleName;
  }
  return null;
}

export function getChainForBone(
  mapping: MappingResult | null,
  boneRef: string | null,
): string | null {
  if (!mapping || !boneRef) return null;
  return mapping.getChainForBone(boneRef);
}

export function buildConnectionKey(from: string, to: string): string {
  return from.localeCompare(to) <= 0 ? `${from}::${to}` : `${to}::${from}`;
}
